export const extracurriculars = {
  title: "Extracurricular Activities", 
  metaDescription: "Extracurricular activities at Gándara International School - English, Music, Circus, Imaxina and more",
  weeklySchedule: {
    title: "Weekly Schedule",
    filterLabels: {
      english: "English",
      xogos: "Games",
      music: "Music", 
      circus: "Circus",
      search: "Search activity… (e.g. English)"
    },
    schedule: [
      {
        day: "Monday",
        subtitle: "English Starters & Imaxina",
        sessions: [
          {
            title: "English Starters Group 1",
            time: "3:30 PM to 4:30 PM",
            instructor: "Patri",
            badge: "3-5 years",
            tags: ["english"]
          },
          {
            title: "English Starters Group 2", 
            time: "4:30 PM to 5:30 PM",
            instructor: "Patri",
            badge: "3-5 years",
            tags: ["english"]
          },
          {
            title: "Imaxina",
            time: "4:30 PM to 6:30 PM",
            instructor: "Xavi",
            badge: "8–12 years",
            tags: ["imaxina", "creativity"]
          }
        ]
      },
      {
        day: "Tuesday",
        subtitle: "English Advance",
        sessions: [
          {
            title: "English Advance Group 1",
            time: "3:30 PM to 4:30 PM",
            instructor: "Sandra",
            badge: "6–12 years",
            tags: ["english"]
          },
          {
            title: "English Advance Group 2",
            time: "4:30 PM to 5:30 PM", 
            instructor: "Sandra",
            badge: "6–12 years",
            tags: ["english"]
          }
        ]
      },
      {
        day: "Wednesday",
        subtitle: "Board Games (8-12 years)",
        sessions: [
          {
            title: "Board Games",
            time: "4:30 PM to 6:30 PM",
            instructor: "Xavi",
            badge: "8–12 years",
            tags: ["xogos"]
          }
        ]
      },
      {
        day: "Thursday",
        subtitle: "Music Workshop & Circus",
        sessions: [
      {
        title: "LET'S PLAY GUITAR",
        time: "3:30 PM to 4:30 PM",
        instructor: "Óscar",
        badge: "8–12 years",
        tags: ["music"]
      },
      {
        title: "ENJOY THE MUSIC",
        time: "4:30 PM to 5:30 PM",
        instructor: "Óscar",
        badge: "5-8 years",
        tags: ["music"]
      },
          {
            title: "Circus",
            time: "5:30 PM to 6:30 PM",
            instructor: "",
            badge: "8–12 years",
            tags: ["circus"]
          }
        ]
      }
    ]
  },
  ludoteca: {
    title: "Ludoteca Service",
    schedule: "Ludoteca schedule: 3:30 PM to 6:30 PM",
    freeService: "Free when taking lunch or another extracurricular activity",
    pricing: {
      title: "Ludoteca prices without lunch or extracurriculars:",
      dayPass: "Single day: 8€/day",
      oneDay: "One day per week: 25€/month",
      twoDays: "Two days per week: 40€/month",
      fiveDays: "Five days per week: 100€/month"
    }
  },
  activities: {
    title: "Extracurricular Activities - Prices",
    list: [
      {
        name: "Imaxina",
        age: "8-12 years",
        price: "40 €/month",
        description: "Accompaniment and learning through role-playing games"
      },
      {
        name: "Board Games",
        age: "8-12 years",
        price: "40 €/month", 
        description: "Accompaniment through board games"
      },
      {
        name: "Playful-experiential English",
        age: "3-12 years",
        price: "40 €/month",
        description: "Through games, music, arts..."
      },
      {
        name: "Circus in English",
        age: "6-12 years",
        price: "35 €/month",
        description: "Learning circus techniques in English"
      },
      {
        name: "ENJOY THE MUSIC",
        age: "5-8 years",
        price: "40 €/month",
        description: "Musical initiation for the youngest"
      },
      {
        name: "LET'S PLAY GUITAR",
        age: "8-12 years",
        price: "40 €/month", 
        description: "Guitar learning for children"
      }
    ]
  },
  contact: {
    info: "More information and registrations",
    description: "For more information and/or to register:",
    email: "info@gandaraschool.com"
  }
};